"use client";

import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import { defaultContent, safeGenerateHTML } from "@/ui/admin/tiptap-utils";
import { TabsRichText } from "./tabs-rich-text";
export const TabsClient = t0 => {
  const $ = _c(16);
  const {
    items,
    isBuilder
  } = t0;
  const [activeTabIdx, setActiveTabIdx] = useState(0);
  const activeItem = items[activeTabIdx];
  let t1;
  if ($[0] !== activeTabIdx || $[1] !== items) {
    let t2;
    if ($[3] !== activeTabIdx) {
      t2 = (item, idx) => <button type="button" key={item.id} onClick={() => setActiveTabIdx(idx)} className={`py-2 px-1 border-b-2 font-medium text-sm transition-colors duration-200 ${activeTabIdx === idx ? "border-neutral-700 text-neutral-700" : "border-transparent text-neutral-500 hover:text-neutral-700 hover:border-neutral-300"}`} aria-current={activeTabIdx === idx ? "page" : undefined}>{item.title}</button>;
      $[3] = activeTabIdx;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    t1 = items.map(t2);
    $[0] = activeTabIdx;
    $[1] = items;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[5] !== t1) {
    t2 = <div className="border-b border-neutral-200"><nav className="-mb-px flex space-x-8" aria-label="Tabs">{t1}</nav></div>;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== activeItem || $[8] !== activeTabIdx || $[9] !== isBuilder) {
    t3 = activeItem && <div key={activeItem.id} className="prose prose-theme max-w-none! h-full *:h-full" data-yns-click={true}>{isBuilder ? <TabsRichText key={activeTabIdx} content={activeItem.content} idx={activeTabIdx} /> : <div className="tiptap-result *:first:mt-0" dangerouslySetInnerHTML={{
        __html: safeGenerateHTML(activeItem.content || defaultContent)
      }} />}</div>;
    $[7] = activeItem;
    $[8] = activeTabIdx;
    $[9] = isBuilder;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== t3) {
    t4 = <div className="">{t3}</div>;
    $[11] = t3;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== t2 || $[14] !== t4) {
    t5 = <div className="w-full mx-auto">{t2}{t4}</div>;
    $[13] = t2;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  return t5;
};